import { render, staticRenderFns } from "./VerifyAccountAlert.vue?vue&type=template&id=d6ef13da&"
import script from "./VerifyAccountAlert.vue?vue&type=script&lang=js&"
export * from "./VerifyAccountAlert.vue?vue&type=script&lang=js&"
import style0 from "./VerifyAccountAlert.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports